import {
  Button,
  Table,
  Grid,
  Box,
  Autocomplete,
  TextField,
  Collapse,
  createFilterOptions,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  IconButton,
  Dialog,
  Radio,
  FormControlLabel,
  RadioGroup,
  CircularProgress,
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import EamLogoDoc from "../../../images/EamLogoDoc.png";
import {
  ArrowBack,
  Clear,
  SignalCellularNullOutlined,
} from "@mui/icons-material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { masterAPI } from "../../Masters/dataConfig";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment";
import { fromUTC, getCurrentInTimeZone } from "../../../utils/dateUtil";

const StockTakeDocument = ({ data, mode, handleCloseClick,onChangeStockTaking,stockTakingNameValue,print,handleCreateFromAdjClose,createFromAdj }) => {

  const [loading, setLoading] = useState(false);
  const [stockTakingId, setStockTakinId] = useState(null);
  const [adjustedData, setAdjustedData] = useState([]);
  const navigate = useNavigate();
  console.log(adjustedData);
  const editData = useSelector(
    (state) => state.editData.inventoryAdjustmentData.data
  );
  const edit = useSelector(
    (state) => state.editData.inventoryAdjustmentData.edit
  );
  const [stockTakingNo, setStockTakingNo] = useState("")
  const [stockTakingName, setStockTakingName] = useState("")
  const [create, setCreate] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [open, setOpen] = useState(true);
  const [stockRoomData, setStockRoomData] = useState([]);
  const [aisleData, setAisleData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [binData, setBinData] = useState([]);
  const [partData, setPartData] = useState([]);
  const currentDate = new Date();
  const formattedDate = editData.createdDate ? fromUTC(editData.createdDate).tzString : getCurrentInTimeZone().tzString;
  console.log("partData", partData);
  const [selectData, setSelectData] = useState({
    stockRoom: {
      id: null,
      autoText: "",
    },
    aisle: {
      id: null,
      autoText: "",
    },
    row: {
      id: null,
      autoText: "",
    },
    bin: {
      id: null,
      autoText: "",
    },
  });
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };
  useEffect(() => {
    getData();
    initializeData();
  }, [data, partData, editData, edit]);

  

  const getData = async () => {
    const getStockRoom = masterAPI["selectList"].stockRoom;
    await axiosPrivate
      .get(`${getStockRoom}`)
      .then((res) => {
        setStockRoomData(res.data);
      })
      .catch((e) => {
        console.log(e, "error");
      });
  };

  const handleStockRoom = async (id) => {
    const getAisle = masterAPI["selectList"].stockRoomAisle;
    await axiosPrivate
      .get(`${getAisle}/${id}`)
      .then((res) => {
        setAisleData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleAisle = async (id) => {
    const getRow = masterAPI["selectList"].stockRoomAisleRow;
    await axiosPrivate
      .get(`${getRow}/${id}`)
      .then((res) => {
        setRowData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleRow = async (id) => {
    const getBin = masterAPI["selectList"].stockRoomAisleRowBin;
    await axiosPrivate
      .get(`${getBin}/${id}`)
      .then((res) => {
        setBinData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleSearch = async () => {
    const searchData = {
      stockRoomId: selectData.stockRoom.id,
      stockRoomAisleId: selectData.aisle.id,
      stockRoomRowId: selectData.row.id,
      stockRoomBinId: selectData.bin.id,
    };
    console.log(searchData);
    const searchLink = masterAPI["inventory"].search;
    await axiosPrivate
      .post(`${searchLink}`, searchData)
      .then((res) => {
        console.log(res);
        setPartData(res.data.result);
      })
      .catch((e) => {
        console.log(e);
        toast.error(e.response.data.failureMessage);
      });
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printable-content").innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  console.log("editData", editData);
  const initializeData = () => {
    if (edit === true && editData) {
      setStockTakingNo(editData.stockTakingNo || "");
      setStockTakinId(editData.id || null);
      setStockTakingName(editData.stockTakingName || "");
      if (editData.isNoStockUpdateKeepSTList) {
        setSelectedValue("isNoStockUpdateKeepSTList");
      } else if (editData.isUpdateCountedStockDeleteSTList) {
        setSelectedValue("isUpdateCountedStockDeleteSTList");
      } else if (editData.isUpdateCountedStockRemoveFromSTList) {
        setSelectedValue("isUpdateCountedStockRemoveFromSTList");
      } else if (editData.isUpdateSystemQuantity) {
        setSelectedValue("isUpdateSystemQuantity");
      }

      const inventoryAdjustmentList = partData?.length
        ? partData
        : editData.inventoryAdjustmentList;

      setAdjustedData(
        inventoryAdjustmentList.map((item) => ({
          partId: item.partId,
          partName: item.partName,
          stockRoomName: item.stockRoomName,
          binName: item.binName,
          partsInventoryId: item.partsInventoryId,
          rowName: item.rowName,
          aisleName: item.aisleName,
          code: item.code,
          stockRoomId: item.stockRoomId,
          stockRoomRowAisleId: item.stockRoomRowAisleId,
          stockRoomRowBinId: item.stockRoomRowBinId,
          stockRoomRowId: item.stockRoomRowId,
          systemQuantityInBin:
            editData.inventoryAdjustmentList.length > 0
              ? item.systemQuantityInBin == 0
                ? "-"
                : item.systemQuantityInBin
              : item.quantityOnHandInBin == 0
              ? "-"
              : item.quantityOnHandInBin,
          systemQuantityInAisle:
            editData.inventoryAdjustmentList.length > 0
              ? item.systemQuantityInAisle == 0
                ? "-"
                : item.systemQuantityInAisle
              : item.quantityOnHandInAisle == 0
              ? "-"
              : item.quantityOnHandInAisle,
          systemQuantityInRow:
            editData.inventoryAdjustmentList.length > 0
              ? item.systemQuantityInRow == 0
                ? "-"
                : item.systemQuantityInRow
              : item.quantityOnHandInRow == 0
              ? "-"
              : item.quantityOnHandInRow,
          systemQuantityInRoom:
            editData.inventoryAdjustmentList.length > 0
              ? item.systemQuantityInRoom == 0
                ? "-"
                : item.systemQuantityInRoom
              : item.quantityOnHandInRoom == 0
              ? "-"
              : item.quantityOnHandInRoom,
          actualQuantityInBin:
            editData.inventoryAdjustmentList.length > 0
              ? item.actualQuantityInBin == 0
                ? "-"
                : item.actualQuantityInBin
              : item.quantityOnHandInBin == 0
              ? "-"
              : item.quantityOnHandInBin,
          actualQuantityInAisle:
            editData.inventoryAdjustmentList.length > 0
              ? item.actualQuantityInAisle == 0
                ? "-"
                : item.actualQuantityInAisle
              : item.quantityOnHandInAisle == 0
              ? "-"
              : item.quantityOnHandInAisle,
          actualQuantityInRow:
            editData.inventoryAdjustmentList.length > 0
              ? item.actualQuantityInRow == 0
                ? "-"
                : item.actualQuantityInRow
              : item.quantityOnHandInRow == 0
              ? "-"
              : item.quantityOnHandInRow,
          actualQuantityInRoom:
            editData.inventoryAdjustmentList.length > 0
              ? item.actualQuantityInRoom == 0
                ? "-"
                : item.actualQuantityInRoom
              : item.quantityOnHandInRoom == 0
              ? "-"
              : item.quantityOnHandInRoom,
          qrCodeData: item.qrCodeData,
          id: item.id,
        }))
      );
    } else if (data && data.length > 0) {
      setAdjustedData(
        data.map((item) => ({
          partId: item.partId,
          stockRoomId: item.stockRoomId,
          partName: item.partName,
          code: item.code,
          stockRoomRowAisleId: item.stockRoomRowAisleId,
          stockRoomRowBinId: item.stockRoomRowBinId,
          stockRoomRowId: item.stockRoomRowId,
          systemQuantityInBin:
            item.quantityOnHandInBin == 0 ? "-" : item.quantityOnHandInBin,
          systemQuantityInAisle:
            item.quantityOnHandInAisle == 0 ? "-" : item.quantityOnHandInAisle,
          systemQuantityInRow:
            item.quantityOnHandInRow == 0 ? "-" : item.quantityOnHandInRow,
          systemQuantityInRoom:
            item.quantityOnHandInRoom == 0 ? "-" : item.quantityOnHandInRoom,
          stockRoomName: item.stockRoomName,
          binName: item.binName,
          rowName: item.rowName,
          aisleName: item.aisleName,
          actualQuantityInBin:
            item.quantityOnHandInBin == 0 ? null : item.quantityOnHandInBin,
          actualQuantityInAisle:
            item.quantityOnHandInAisle == 0 ? null : item.quantityOnHandInAisle,
          actualQuantityInRow:
            item.quantityOnHandInRow == 0 ? null : item.quantityOnHandInRow,
          actualQuantityInRoom:
            item.quantityOnHandInRoom == 0 ? null : item.quantityOnHandInRoom,
          qrCodeData: "a",
          id: item.id,
        }))
      );
    }
  };
  const handleChange = (e, partId, binId, rowId, roomId, aisleId, field) => {
    const { value } = e.target;

    const updatedData = adjustedData.map((item) =>
      item.partId === partId &&
      item.stockRoomRowBinId === binId &&
      item.stockRoomRowId === rowId &&
      item.stockRoomRowAisleId === aisleId &&
      item.stockRoomId === roomId
        ? { ...item, [field]: value }
        : item
    );

    setAdjustedData(updatedData);
  };

  const handleSubmit = async () => {
    setLoading(true);

    const payload = {
      stockTakingNo: stockTakingNo,
      stockTakingName: stockTakingName,
      isNoStockUpdateKeepSTList: selectedValue === "isNoStockUpdateKeepSTList",
      isUpdateCountedStockDeleteSTList:
        selectedValue === "isUpdateCountedStockDeleteSTList",
      isUpdateCountedStockRemoveFromSTList:
        selectedValue === "isUpdateCountedStockRemoveFromSTList",
      isUpdateSystemQuantity: selectedValue === "isUpdateSystemQuantity",
      ...(stockTakingId && { id: stockTakingId }),
      inventoryAdjustmentList: adjustedData.map((item) => ({
        id: item.id,
        partId: item.partId,
        partsInventoryId: item.partsInventoryId,
        stockRoomId: item.stockRoomId,
        stockRoomRowId: item.stockRoomRowId,
        stockRoomRowBinId: item.stockRoomRowBinId,
        stockRoomRowAisleId: item.stockRoomRowAisleId,
        systemQuantityInBin:
          item.systemQuantityInBin === "-" ? 0 : item.systemQuantityInBin,
        systemQuantityInAisle:
          item.systemQuantityInAisle === "-" ? 0 : item.systemQuantityInAisle,
        systemQuantityInRow:
          item.systemQuantityInRow === "-" ? 0 : item.systemQuantityInRow,
        systemQuantityInRoom:
          item.systemQuantityInRoom === "-" ? 0 : item.systemQuantityInRoom,
        actualQuantityInBin: item.actualQuantityInBin || 0,
        actualQuantityInAisle: item.actualQuantityInAisle || 0,
        actualQuantityInRow: item.actualQuantityInRow || 0,
        actualQuantityInRoom: item.actualQuantityInRoom || 0,
        qrCodeData: item.qrCodeData,
        stockTakingNo: stockTakingNo,
      })),
    };
    if (payload.inventoryAdjustmentList.length === 0) {
      toast.error("Stock Taking list cannot be empty.");
      setLoading(false);
      return false;
    }
    // if (payload.stockTakingNo === "" && payload.stockTakingName === "") {
    //   toast.error("Stock Taking No and Stock Taking Name cannot be empty.");
    //   setLoading(false);
    //   return false;
    // }
    console.log("Payload being sent to API:", payload);

    const apiUrl =
      edit === true
        ? masterAPI["inventory"].bulkStockTakinUpdate
        : masterAPI["inventory"].bulkStockTaking;

    await axiosPrivate
      .post(apiUrl, payload)
      .then((response) => {
        console.log("API Response:", response.data);
        if(print){
            handlePrint()
        }else{
            navigate("/inventory/inventoryadjustmentlist");
        }
        
      })
      .catch((error) => {
        console.error("Error submitting data to API:", error);
        toast.error(error.response.data.failureMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const cellStyles = {
    backgroundColor: "transparent",
    padding: "1rem 0.4rem",
    textAlign: "center",
    fontSize: "13px",
    whiteSpace: "nowrap",
    fontWeight: 700,
    borderRight: "1px solid #e0e0e0",
  };
  const counted = {
    backgroundColor: "transparent",
    padding: "0.4rem",
    fontSize: "12px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    textAlign: "center",
  };
  const cellResponse = {
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 600,
    color: "#797979",
    border: "none",
    borderRight: "1px solid #e0e0e0",
    padding: "0.4rem",
  };
  const handleOpenDialog = () => {
     if (stockTakingNo.trim()==="" || stockTakingName?.trim()==="") {
          toast.error("Stocktaking No and Stocktaking Name are required");
          return;
        }
    setCreate(true);
  };
  const handleCreateClose = () => {
    setCreate(false);
    if(!edit){
    handleCreateFromAdjClose();
    } 
   };
  return (
    <>
      <Box
        sx={{ display: edit ? "flex" : "none", alignItems: "center", gap: 1 }}
      >
        <Link to="/inventory/inventoryadjustmentlist">
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
          }}
        >
          Inventory Count Update
        </Typography>
      </Box>
      <Grid
        item
        xs={12}
        mb={2}
        sx={{
          display: editData.isUpdateCountedStockRemoveFromSTList
            ? "default"
            : "none",
        }}
      >
        <Paper sx={{ padding: "1rem" }}>
          <Grid container alignItems={"center"}>
            <Grid item xs={6}>
              <Typography
                sx={{
                  color: "#2362B4",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  {open ? (
                    <KeyboardArrowUpIcon
                      sx={{ fontSize: "1.7rem", color: "#2362B4" }}
                    />
                  ) : (
                    <KeyboardArrowDown
                      sx={{ fontSize: "1.7rem", color: "#2362B4" }}
                    />
                  )}{" "}
                </IconButton>
                Filter
              </Typography>
            </Grid>
            <Grid container item xs={6} justifyContent={"flex-end"}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2362B4", color: "white", mr: 2 }}
                onClick={handleSearch}
              >
                Search
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2362B4", color: "white", mr: 2 }}
                component={Link}
                to="/inventory/inventoryadjustmentlist"
              >
                Stock Take List
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2362B4", color: "white" }}
                onClick={handlePrint}
              >
                Print
              </Button>
            </Grid>
          </Grid>
          <Collapse in={open} timeout={"auto"} unmountOnExit>
            <Grid container spacing={"1.5rem"}>
              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontFamily: "Nunito Sans, sans-serif",
                    fontWeight: 600,
                    color: "#656565",
                    mb: "0.1rem",
                  }}
                >
                  Stock Room
                </Typography>
                <Autocomplete
                  name="stockRoomId"
                  //  value={autoValue}
                  // value={values.assetName.code+"_"+values.assetName.assetName}
                  inputValue={selectData.stockRoom.autoText}
                  filterOptions={filterOptions}
                  loading={stockRoomData.length === 0}
                  options={stockRoomData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text || option}
                  freeSolo
                  onChange={(event, value) => {
                    if (value) {
                      console.log(value);
                      setSelectData({
                        ...selectData,
                        stockRoom: {
                          id: value.value,
                          autoText: value.text,
                        },
                      });
                      handleStockRoom(value.value);
                    } else {
                      setSelectData({
                        ...selectData,
                        stockRoom: {
                          id: null,
                          autoText: "",
                        },
                      });
                      // setFieldValue("failureClassId",null)
                    }
                  }}
                  onInputChange={(e, v) => {
                    setSelectData({
                      ...selectData,
                      stockRoom: { ...selectData.stockRoom, autoText: v },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Stockroom"
                      // onChange={handleChange}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {stockRoomData.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                >
                  {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                </Autocomplete>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontFamily: "Nunito Sans, sans-serif",
                    fontWeight: 600,
                    color: "#656565",
                    mb: "0.1rem",
                  }}
                >
                  Aisle
                </Typography>
                <Autocomplete
                  name="aisleId"
                  //  value={autoValue}
                  // value={values.assetName.code+"_"+values.assetName.assetName}
                  inputValue={selectData.aisle.autoText}
                  filterOptions={filterOptions}
                  //   loading={aisleData.length === 0}
                  options={aisleData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text || option}
                  freeSolo
                  onChange={(event, value) => {
                    if (value) {
                      console.log(value);
                      setSelectData({
                        ...selectData,
                        aisle: {
                          id: value.value,
                          autoText: value.text,
                        },
                      });
                      handleAisle(value.value);
                    } else {
                      setSelectData({
                        ...selectData,
                        aisle: {
                          id: null,
                          autoText: "",
                        },
                      });
                      // setFieldValue("failureClassId",null)
                    }
                  }}
                  onInputChange={(e, v) => {
                    setSelectData({
                      ...selectData,
                      aisle: { ...selectData.aisle, autoText: v },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Aisle"
                      // onChange={handleChange}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {aisleData.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                >
                  {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                </Autocomplete>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontFamily: "Nunito Sans, sans-serif",
                    fontWeight: 600,
                    color: "#656565",
                    mb: "0.1rem",
                  }}
                >
                  Row
                </Typography>
                <Autocomplete
                  name="rowId"
                  //  value={autoValue}
                  // value={values.assetName.code+"_"+values.assetName.assetName}
                  inputValue={selectData.row.autoText}
                  filterOptions={filterOptions}
                  //   loading={rowData.length === 0}
                  options={rowData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text || option}
                  freeSolo
                  onChange={(event, value) => {
                    if (value) {
                      console.log(value);
                      setSelectData({
                        ...selectData,
                        row: {
                          id: value.value,
                          autoText: value.text,
                        },
                      });
                      handleRow(value.value);
                    } else {
                      setSelectData({
                        ...selectData,
                        row: {
                          id: null,
                          autoText: "",
                        },
                      });
                      // setFieldValue("failureClassId",null)
                    }
                  }}
                  onInputChange={(e, v) => {
                    setSelectData({
                      ...selectData,
                      row: { ...selectData.row, autoText: v },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Row"
                      // onChange={handleChange}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {rowData.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                >
                  {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                </Autocomplete>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography
                  sx={{
                    fontFamily: "Nunito Sans, sans-serif",
                    fontWeight: 600,
                    color: "#656565",
                    mb: "0.1rem",
                  }}
                >
                  Bin
                </Typography>
                <Autocomplete
                  name="rowId"
                  //  value={autoValue}
                  // value={values.assetName.code+"_"+values.assetName.assetName}
                  inputValue={selectData.bin.autoText}
                  filterOptions={filterOptions}
                  //   loading={binData.length === 0}
                  options={binData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text || option}
                  freeSolo
                  onChange={(event, value) => {
                    if (value) {
                      console.log(value);
                      setSelectData({
                        ...selectData,
                        bin: {
                          id: value.value,
                          autoText: value.text,
                        },
                      });
                    } else {
                      setSelectData({
                        ...selectData,
                        bin: {
                          id: null,
                          autoText: "",
                        },
                      });
                      // setFieldValue("failureClassId",null)
                    }
                  }}
                  onInputChange={(e, v) => {
                    setSelectData({
                      ...selectData,
                      bin: { ...selectData.bin, autoText: v },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Bin"
                      // onChange={handleChange}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {binData.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                ></Autocomplete>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </Grid>
      <Paper sx={{ p: "2rem" }}>
        <Grid container alignItems="center" sx={{ padding: 2 }}>
          <Grid item xs={6} sm={3}>
            <Box
              component="img"
              src={EamLogoDoc}
              alt="EAM Logo"
              sx={{
                width: 250,
                height: "auto",
                mt: -10,
                p: 1,
                marginLeft: "-2rem",
              }}
            />
          </Grid>
        </Grid>
        <Grid sx={{ textAlign: "center", mt: -15 }}>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Inventory Count List
          </Typography>
        </Grid>
        <Grid sx={{ textAlign: "right" }}>
          <Typography
            sx={{
              fontFamily: "Nunito Sans, sans-serif",
              fontWeight: "bold",
              color: "#656565",
              mb: "1rem",
            }}
          >
            Printed: {formattedDate}
          </Typography>
        </Grid>

        <Grid sx={{ textAlign: "right" }}>
          <Typography
            sx={{
              fontFamily: "Nunito Sans, sans-serif",
              fontWeight: "bold",
              color: "#656565",
            }}
          >
            {/* Stock Room: {data[0] ? data[0].stockRoomName : null} */}
          </Typography>
        </Grid>
        {/* <Grid sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontWeight: "bold",
            color: "#656565",
          }}
        >
          Aisle: {data[0] ? data[0].aisleName : null}
        </Typography>
      </Grid>
      <Grid sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontWeight: "bold",
            color: "#656565",
          }}
        >
          Row: {data[0] ? data[0].rowName : null}
        </Typography>
      </Grid>
      <Grid sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontWeight: "bold",
            color: "#656565",
          }}
        >
          Bin: {data[0] ? data[0].binName : null}
        </Typography>
      </Grid> */}
        <Grid mt={-5}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3} mb={2}>
              <Typography
                sx={{
                  fontFamily: "Nunito Sans, sans-serif",
                  fontWeight: "bold",
                  color: "#656565",
                }}
              >
                Inventory Count Code:
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                size="small"
                type="text"
                fullWidth
                variant="standard"
                value={stockTakingNo}
                onChange={(e) => {
                  setStockTakingNo(e.target.value);
                  if(!edit){
                     onChangeStockTaking("stockTakingNo",e)}
                  }
                }
                sx={{ maxWidth: "200px", ml: -10, mt: -1 }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3} mb={2}>
              <Typography
                sx={{
                  fontFamily: "Nunito Sans, sans-serif",
                  fontWeight: "bold",
                  color: "#656565",
                }}
              >
                Inventory Count Name:
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                size="small"
                type="text"
                fullWidth
                variant="standard"
                value={stockTakingName}
                onChange={(e) => {
                  if(!edit){
                     onChangeStockTaking("stockTakingName",e)
                    }
                     setStockTakingName(e.target.value);
                  }
                  
                }
                sx={{ maxWidth: "200px", ml: -10, mt: -1 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{...cellStyles, borderLeft: "1px solid #e0e0e0" }}>Code</TableCell>
                  <TableCell sx={cellStyles}>Part Name</TableCell>
                  <TableCell sx={cellStyles}>Stock Room Name</TableCell>
                  <TableCell sx={cellStyles}>Quantity In Room</TableCell>
                  <TableCell sx={cellStyles}>Aisle Name</TableCell>
                  <TableCell sx={cellStyles}>Quantity In Aisle</TableCell>
                  <TableCell sx={cellStyles}>Row Name</TableCell>
                  <TableCell sx={cellStyles}>Quantity In Row</TableCell>
                  <TableCell sx={cellStyles}>Bin Name</TableCell>
                  <TableCell sx={{ ...cellStyles}}>
                    Quantity In Bin
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {adjustedData.map((item) => (
                  <React.Fragment key={item.id}>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell sx={{...cellResponse, borderLeft: "1px solid #e0e0e0"}}>{item.code}</TableCell>
                      <TableCell sx={cellResponse}>{item.partName}</TableCell>
                      <TableCell sx={cellResponse}>
                        {item.stockRoomName}
                      </TableCell>
                      <TableCell sx={cellResponse}>
                        {item.systemQuantityInRoom}
                      </TableCell>
                      <TableCell sx={cellResponse}>{item.aisleName}</TableCell>
                      <TableCell sx={cellResponse}>
                        {item.systemQuantityInAisle}
                      </TableCell>
                      <TableCell sx={cellResponse}>{item.rowName}</TableCell>
                      <TableCell sx={cellResponse}>
                        {item.systemQuantityInRow}
                      </TableCell>
                      <TableCell sx={cellResponse}>{item.binName}</TableCell>
                      <TableCell sx={cellResponse}>
                        {item.systemQuantityInBin}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{...counted, borderLeft: "1px solid #e0e0e0"}}>Counted Quantity</TableCell>
                      <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}></TableCell>
                      <TableCell sx={counted}>{item.stockRoomName}</TableCell>

                      <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          variant="standard"
                          value={item.actualQuantityInRoom ?? ""}
                          placeholder="-"
                          onChange={(e) =>
                            handleChange(
                              e,
                              item.partId,
                              item.stockRoomRowBinId,
                              item.stockRoomRowId,
                              item.stockRoomId,
                              item.stockRoomRowAisleId,
                              "actualQuantityInRoom"
                            )
                          }
                          InputProps={{
                            inputProps: {
                              step: "0.01",
                              style: {
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                              },
                            },
                          }}
                          sx={{
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                              WebkitAppearance: "none",
                              appearance: "none",
                            },
                            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                          }}
                        />
                      </TableCell>
                      <TableCell sx={counted}>{item.aisleName}</TableCell>
                      <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                        <TextField
                          size="small"
                          fullWidth
                          variant="standard"
                          type="number"
                          value={item.actualQuantityInAisle ?? ""}
                          placeholder="-"
                          onChange={(e) =>
                            handleChange(
                              e,
                              item.partId,
                              item.stockRoomRowBinId,
                              item.stockRoomRowId,
                              item.stockRoomId,
                              item.stockRoomRowAisleId,
                              "actualQuantityInAisle"
                            )
                          }
                          InputProps={{
                            inputProps: {
                              step: "0.01",
                              style: {
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                              },
                            },
                          }}
                          sx={{
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                              WebkitAppearance: "none",
                              appearance: "none",
                            },
                            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                          }}
                        />
                      </TableCell>
                      <TableCell sx={counted}>{item.rowName}</TableCell>
                      <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                        <TextField
                          size="small"
                          fullWidth
                          type="number"
                          variant="standard"
                          value={item.actualQuantityInRow ?? ""}
                          placeholder="-"
                          onChange={(e) =>
                            handleChange(
                              e,
                              item.partId,
                              item.stockRoomRowBinId,
                              item.stockRoomRowId,
                              item.stockRoomId,
                              item.stockRoomRowAisleId,
                              "actualQuantityInRow"
                            )
                          }
                          InputProps={{
                            inputProps: {
                              step: "0.01",
                              style: {
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                              },
                            },
                          }}
                          sx={{
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                              WebkitAppearance: "none",
                              appearance: "none",
                            },
                            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                          }}
                        />
                      </TableCell>
                      <TableCell sx={counted}>{item.binName}</TableCell>
                      <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          variant="standard"
                          value={item.actualQuantityInBin ?? ""}
                          placeholder="-"
                          onChange={(e) =>
                            handleChange(
                              e,
                              item.partId,
                              item.stockRoomRowBinId,
                              item.stockRoomRowId,
                              item.stockRoomId,
                              item.stockRoomRowAisleId,
                              "actualQuantityInBin"
                            )
                          }
                          InputProps={{
                            inputProps: {
                              step: "0.01",
                              style: {
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                              },
                            },
                          }}
                          sx={{
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                              WebkitAppearance: "none",
                              appearance: "none",
                            },
                            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                            height: "30px", // Adjust cell height
                            minHeight: "30px",
                            padding: "0px",
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          container
          item
          xs={11.9}
          justifyContent={"flex-end"}
          gap="1rem"
          mt={2}
          mb={5}
          sx={{
            "@media print": {
              display: "none",
            },
          }}
        >
          <Button
            variant="contained"
            onClick={handleCloseClick}
            sx={{
              backgroundColor: "#f5f5f5",
              textTransform: "none",
              color: "#000",
              ":hover": {
                backgroundColor: "#f5f5f5",
                textTransform: "none",
                color: "#000",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOpenDialog}
            variant="contained"
            disabled={loading}
            sx={{
              textTransform: "none",
              backgroundColor: loading ? "#ccc" : "#1976d2",
              "&:hover": {
                backgroundColor: loading ? "#ccc" : "#1565c0",
              },
            }}
          >
            Register
          </Button>
        </Grid>
      </Paper>
      <Dialog open={create||createFromAdj} onClose={handleCreateClose} maxWidth="sm">
        <Box sx={{ p: color.masterPageDialogPadding }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: color.masterDialogTitleColor,
                fontSize: color.masterDialogFontSize,
              }}
            >
              Stock Taking Registration
            </Typography>
            <IconButton onClick={handleCreateClose}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
          <RadioGroup
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            <FormControlLabel
              value="isNoStockUpdateKeepSTList"
              control={<Radio />}
              label="Maintain Counted Quantity and Inventory Count list"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "13px",
                  fontWeight: 700,
                },
              }}
            />
            <FormControlLabel
              value="isUpdateCountedStockDeleteSTList"
              control={<Radio />}
              label="Update Counted Quantity and Delete the Inventory Count List"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "13px",
                  fontWeight: 700,
                },
              }}
            />
            <FormControlLabel
              value="isUpdateCountedStockRemoveFromSTList"
              control={<Radio />}
              label="Update Counted Quantity and Remove from the Inventory Count List"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "13px",
                  fontWeight: 700,
                },
              }}
            />
            <FormControlLabel
              value="isUpdateSystemQuantity"
              control={<Radio />}
              label="Update Counted Inventory and Mark the Other Inventory Items as Counted"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "13px",
                  fontWeight: 700,
                },
              }}
            />
          </RadioGroup>
          <Grid item xs={12} textAlign="right">
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
              sx={{
                textTransform: "none",
                backgroundColor: loading ? "#ccc" : "#1976d2",
                "&:hover": {
                  backgroundColor: loading ? "#ccc" : "#1565c0",
                },
              }}
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};

export default StockTakeDocument;
